import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { Event, SocketContext } from '../../../../socketProvider';

import EventMetricsData from './EventMetricsData';
import { AlertsListener } from './AlertsDropdown';
import { getMetrics } from './api';
import { toggleMetrics, setMetrics } from './actions';
import { setCamQueue } from '../../../../store/actions/cameras';
import { eventStatus, socketEventNames } from '../../../../helpers/constants';

import style from './style.module.scss';

const { MONITOR_QUEUE_ARRAY } = socketEventNames;

const EventMetrics = ({
  slug,
  isCollapsed,
  isEventLive,
  toggleMetricsAction,
  setMetricsAction,
  setCamQueueAction,
}) => {
  const socket = useContext(SocketContext);

  useEffect(() => {
    if (!isEventLive) {
      return;
    }

    getMetrics().then((data) => {
      setMetricsAction(data || {
        peak: 0,
        current: 0,
        snapshots: 0,
        shares: 0,
      });
    }).catch((err) => console.error(err));
  }, [isEventLive, setMetricsAction]);

  useEffect(() => {
    if (!isEventLive || !slug) {
      return;
    }

    socket?.emit('getInitTotalQueue', '', slug, (queues) => {
      queues.forEach((queue, camInd) => {
        setCamQueueAction(`cam${camInd + 1}`, queue);
      });
    });
  }, [slug, isEventLive, socket, setCamQueueAction]);

  if (!isEventLive) {
    return null;
  }

  return (
    <>
      <Event event="monitor liveMetricsUsers" handler={setMetricsAction} />
      <Event event="monitor liveMetricsSnapshots" handler={setMetricsAction} />
      <Event event="monitor liveMetricsShares" handler={setMetricsAction} />
      <Event event={MONITOR_QUEUE_ARRAY} handler={setCamQueueAction} />
      <AlertsListener />
      <div className={classnames(style.wrapper, { [style.isCollapsed]: isCollapsed })}>
        <div className={style.btnWrapper}>
          <Button
            variant="light"
            className={style.liveMetricsBtn}
            onClick={toggleMetricsAction}
          >
            {isCollapsed && <FontAwesomeIcon icon={faChevronLeft} />}
            <span>Live Metrics</span>
            {!isCollapsed && <FontAwesomeIcon icon={faChevronRight} />}
          </Button>
        </div>

        <div className={style.data}>
          {!isCollapsed && <EventMetricsData />}
        </div>
      </div>

      <strong className="separator">|</strong>
    </>
  );
};

export default connect(
  ({
    eventMetrics: { isCollapsed },
    events: { slug, currentEvent },
  }) => ({
    slug,
    isCollapsed,
    isEventLive: currentEvent?.eventStatus === eventStatus.LIVE,
  }),
  {
    toggleMetricsAction: toggleMetrics,
    setMetricsAction: setMetrics,
    setCamQueueAction: setCamQueue,
  },
)(EventMetrics);
